<rappider-title-toolbar *ngIf="title"
                        [mainTitle]="title?.mainTitle"
                        [options]="title?.options"></rappider-title-toolbar>

<section *ngIf="showSearchSection">

  <div class="search-filter"
       [ngClass]="{'search-filter-full-width': !buttons?.length && selectConfig?.visibility === false}">
    <div class="search-wrapper">
      <rappider-input-group *ngIf="!detailedSearchActive"
                            [(ngModel)]="searchText"
                            [textbox]="inputGroupConfig?.textbox"
                            [suffixIcon]="searchText ? inputGroupConfig?.suffixIcon : null"
                            (iconClick)="onSearchBarIconClick()">
      </rappider-input-group>
      <rappider-input-group *ngIf="detailedSearchActive"
                            [(ngModel)]="searchTextWithSearchButton"
                            [textbox]="inputGroupConfig?.textbox"
                            [suffixIcon]="searchText ? inputGroupConfig?.suffixIcon : null"
                            (iconClick)="onSearchBarIconClick()"
                            (enterClick)="onSearchButtonClick(searchTextWithSearchButton)">
      </rappider-input-group>
      <rappider-button *ngIf="detailedSearchActive"
                       text="Search"
                       (click)="onSearchButtonClick(searchTextWithSearchButton)"></rappider-button>
    </div>

    <ng-container>
      <div [ngClass]="{'button-and-select-wrapper': selectConfig?.visibility !== false}">
        <div class="buttons">
          <div *ngFor="let button of buttons"
               [ngStyle]="{'float': 'left'}">
            <rappider-button [text]="button.text"
                             [type]="button.type"
                             [shape]="button.shape"
                             [size]="button.size"
                             [transparent]="button.transparent"
                             [loading]="button.loading"
                             [block]="button.loading"
                             [disabled]="button.disabled"
                             [colorType]="button.colorType"
                             [icon]="button.icon"
                             [formButtonType]="button?.formButtonType"
                             [borderSettings]="button?.borderSettings"
                             [customSizeSettings]="button?.customSizeSettings"
                             [customColorSettings]="button?.customColorSettings"
                             [shadowSettings]="button?.shadowSettings"
                             [paddingSettings]="button?.paddingSettings"
                             [marginSettings]="button?.marginSettings"
                             [tooltipText]="button?.tooltipText"
                             (click)="onTopButtonsClick(button)"></rappider-button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>

<section class="searched-list-section"
         *ngIf="(searchedCategoriesFilter?.length || searchedCategoriesTagFilter?.length || searchText) && showSearchFilterLabel && detailedSearchActive">
  <div class="searched-wrapper">
    <div *ngIf="searchedCategoriesFilter?.length"
         class="category-filter-wrapper">
      <rappider-heading content="Category Filter:"
                        type="h6"></rappider-heading>
      <rappider-tag *ngFor="let categoryTag of searchedCategoriesFilter"
                    [text]="{text: categoryTag.key.text}"
                    [icon]="{name: 'fas fa-xmark'}"
                    (click)="onCategoryClick(categoryTag.value)"> </rappider-tag>
    </div>
    <div *ngIf="searchedCategoriesTagFilter?.length"
         class="tag-filter-wrapper">
      <rappider-heading content="Tag Filter:"
                        type="h6"></rappider-heading>
      <rappider-tag *ngFor="let tag of searchedCategoriesTagFilter"
                    [text]="{text: tag.key.text}"
                    [icon]="{name: 'fas fa-xmark'}"
                    (click)="onTagClick(tag.value)"> </rappider-tag>
    </div>
    <div *ngIf="searchText"
         class="search-text-wrapper">
      <rappider-heading content="Search Filter:"
                        type="h6"></rappider-heading>
      <rappider-tag *ngFor="let searchText of searchTexts"
                    [text]="{text: searchText}"> </rappider-tag>
    </div>
    <div *ngIf="detailedSearchActive"
         class="clear-all-wrapper">
      <rappider-button text="Clear All Filters"
                       (click)="clearAll()"
                       size="extra-small"></rappider-button>
    </div>
  </div>
</section>

<section class="searched-list-section"
         *ngIf="!searchedCategoriesFilter?.length && !searchedCategoriesTagFilter?.length && !searchText && showSearchFilterLabel">
  <rappider-heading content="The filters you have selected are displayed here."
                    type="h6"></rappider-heading>
</section>

<section [ngClass]="{'card-one-list-section': menuConfig?.items?.length || selectConfig?.options?.length, 'card-one-list-section-without-menu-config': !menuConfig?.items?.length && !selectConfig?.options?.length}"
         class="cards-container">
  <div *ngIf="titleText"
       class="title-text">
    <rappider-text [content]="titleText?.content"
                   [text]="titleText?.text"
                   [textMode]="titleText?.textMode"
                   [typography]="titleText?.typography"
                   [colorSettings]="titleText?.colorSettings"></rappider-text>
  </div>
  <div *ngIf="menuConfigVisible"
       class="tree-filter-wrapper">
    <nz-collapse>
      <nz-collapse-panel *ngIf="categoryFilterCollapseVisible !== false"
                         nzHeader="Category Filter"
                         [nzActive]="true">
        <rappider-input-group [ngModel]="categoryFilterText"
                              [textbox]="inputGroupConfig?.textbox"
                              [suffixIcon]="categoryFilterText ? inputGroupConfig?.suffixIcon : null"
                              (ngModelChange)="onChangeCategoryFilterText($event)"
                              (iconClick)="onCategoryFilterTextIconClick()">
        </rappider-input-group>
        <rappider-checkbox-list direction="row"
                                [options]="displayedMenuConfig"
                                (itemSelected)="onSelectedCategoryChange($event)"></rappider-checkbox-list>
      </nz-collapse-panel>
      <nz-collapse-panel *ngIf="tagFilterCollapseVisible !== false"
                         nzHeader="Tag Filter"
                         [nzActive]="true">
        <rappider-input-group [ngModel]="tagFilterText"
                              [textbox]="tagInputGroupConfig?.textbox"
                              [suffixIcon]="tagFilterText ? tagInputGroupConfig?.suffixIcon : null"
                              (ngModelChange)="onChangeTagFilterText($event)"
                              (iconClick)="onTagFilterTextIconClick()">
        </rappider-input-group>
        <rappider-checkbox-list direction="row"
                                [options]="tagDisplayedMenuConfig"
                                (itemSelected)="onSelectedTagsChange($event)"></rappider-checkbox-list>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
  <div
       [ngClass]="{'card-one-list-wrapper': menuConfig?.items?.length || selectConfig?.options?.length, 'card-one-list-wrapper-empty': !getDataWithPagination()?.length && detailedSearchActive }">
    <ng-container *ngIf="topCards?.length">
      <div class="top-cards-section">
        <div class="top-cards-wrapper">
          <rappider-spin class="card-one-list-spin-wrapper"
                        [spinning]="isLoading && isLoadingCards"
                        [size]="'default'">
            <rappider-card-one-list [items]="topCards"
                                    [itemCountPerRow]="topCardsItemCountPerRow || itemCountPerRow"
                                    [showTitleOnImage]="showTitleOnImage"
                                    [showDescriptionOnImage]="showDescriptionOnImage"
                                    [showPopover]="showPopover"
                                    [showPopoverImage]="showPopoverImage"
                                    [customIcon]="customIcon"
                                    (imageButtonClick)="onImageButtonClick($event)"
                                    (avatarButtonClick)="onAvatarButtonClick($event)"
                                    (additionalButtonClick)="onAdditionalButtonClick($event)"
                                    (cardClick)="onTopCardClick($event)"></rappider-card-one-list>
          </rappider-spin>
        </div>
        <rappider-divider></rappider-divider>
      </div>
    </ng-container>

    <div *ngIf="topSectionCards?.length"
         class="first-class-of-card-list"
         [ngStyle]="{'height': topSectionHeight}">
      <ng-container *ngFor="let item of topSectionCards">
        <rappider-card-one [data]="item.data"
                           [image]="item.image"
                           [imageTags]="item.imageTags"
                           [imageButtons]="item.imageButtons"
                           [imageButtonPlacement]="item?.imageButtonPlacement"
                           [rate]="item.rate"
                           [titles]="item.titles"
                           [currency]="item.currency"
                           [finalPrice]="item.finalPrice"
                           [price]="item.price"
                           [additionalTags]="item.additionalTags"
                           [additionalButtons]="item.additionalButtons"
                           [descriptions]="item.descriptions"
                           [avatar]="item.avatar"
                           [avatarButton]="item.avatarButton"
                           [avatarPlacement]="item.avatarPlacement"
                           [isSelected]="item.isSelected"
                           [selectedCardIcon]="item.selectedCardIcon"
                           [customIcon]="item.customIcon"
                           [showTitleOnImage]="showTitleOnImage"
                           [showDescriptionOnImage]="showDescriptionOnImage"
                           [showPopover]="showPopover"
                           [showPopoverImage]="showPopoverImage"
                           [disabledCard]="item.disabledCard"
                           [cardTooltipContent]="item.cardTooltipContent"
                           [cardTooltipPlacement]="item.cardTooltipPlacement"
                           [borderSettings]="item.borderSettings"
                           (cardClick)="onTopSectionCardClick($event, item)"></rappider-card-one>
      </ng-container>
    </div>
    <hr *ngIf="topSectionCards?.length">

    <div *ngIf="grouppedCards?.length">
      <div *ngFor="let title of grouppedCards; let isLast = index; let last = last">
        <div *ngIf="getDataWithPagination(title?.value)?.length"
             class="groupped-cards-wrapper"
             [ngClass]="{'last-group': last}">
          <rappider-paragraph [content]="title?.key"
                              [typography]="{fontWeight:'bold'}"></rappider-paragraph>
          <rappider-spin class="card-one-list-spin-wrapper"
                        [spinning]="isLoading && isLoadingCards"
                        [size]="'default'">
            <rappider-card-one-list [items]="getDataWithPagination(title?.value)"
                                    [itemCountPerRow]="itemCountPerRow"
                                    [showTitleOnImage]="showTitleOnImage"
                                    [showDescriptionOnImage]="showDescriptionOnImage"
                                    [showPopover]="showPopover"
                                    [showPopoverImage]="showPopoverImage"
                                    [maxHeight]="bottomSectionHeight"
                                    (imageButtonClick)="onImageButtonClick($event)"
                                    (avatarButtonClick)="onAvatarButtonClick($event)"
                                    (additionalButtonClick)="onAdditionalButtonClick($event)"
                                    (cardClick)="onCardClick($event)"></rappider-card-one-list>
          </rappider-spin>
        </div>
      </div>
    </div>
    <div class="cards-container"
         *ngIf="!grouppedCards?.length && getDataWithPagination()?.length">
      <rappider-spin class="card-one-list-spin-wrapper"
                    [spinning]="isLoading && isLoadingCards"
                    [size]="'default'">
        <rappider-card-one-list [items]="getDataWithPagination()"
                                [itemCountPerRow]="itemCountPerRow"
                                [showTitleOnImage]="showTitleOnImage"
                                [showDescriptionOnImage]="showDescriptionOnImage"
                                [showPopover]="showPopover"
                                [showPopoverImage]="showPopoverImage"
                                [maxHeight]="bottomSectionHeight"
                                (imageButtonClick)="onImageButtonClick($event)"
                                (avatarButtonClick)="onAvatarButtonClick($event)"
                                (additionalButtonClick)="onAdditionalButtonClick($event)"
                                (cardClick)="onCardClick($event)"></rappider-card-one-list>
      </rappider-spin>
    </div>

    <ng-container *ngIf="bottomCards?.length">
      <div class="bottom-cards-section">
        <rappider-divider></rappider-divider>

        <div class="bottom-cards-wrapper">
          <rappider-spin class="card-one-list-spin-wrapper"
                        [spinning]="isLoading && isLoadingCards"
                        [size]="'default'">
            <rappider-card-one-list [items]="bottomCards"
                                    [itemCountPerRow]="bottomCardsItemCountPerRow || itemCountPerRow"
                                    [showTitleOnImage]="showTitleOnImage"
                                    [showDescriptionOnImage]="showDescriptionOnImage"
                                    [showPopover]="showPopover"
                                    [showPopoverImage]="showPopoverImage"
                                    (imageButtonClick)="onImageButtonClick($event)"
                                    (avatarButtonClick)="onAvatarButtonClick($event)"
                                    (additionalButtonClick)="onAdditionalButtonClick($event)"
                                    (cardClick)="onBottomCardClick($event)"></rappider-card-one-list>
          </rappider-spin>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!getDataWithPagination()?.length && detailedSearchActive && showSearchFilterLabel && (searchText || searchedCategoriesFilter?.length || searchedCategoriesTagFilter?.length)"
       class="empty-animation">
    <rappider-lottie-player [options]="emptyAnimationConfig"
                            [width]="'100%'"
                            [height]="'100%'"></rappider-lottie-player>
    <rappider-heading content="No results found. Please update your filters and try again."
                      type="h6"></rappider-heading>
  </div>
  <div *ngIf="!getDataWithPagination()?.length && detailedSearchActive && !showSearchFilterLabel">
    <rappider-heading content="No results found. Try a different search term."
                      type="h6"></rappider-heading>
  </div>
</section>

<div class="footer-wrapper">
  <div *ngIf="isLoading && !isLoadingCards"
       class="loading-wrapper">
    <span nz-icon
          nzType="loading"
          nzTheme="outline"></span>
    <span> {{loadingMessage | translate}}</span>
  </div>
  <div *ngIf="paginationConfig?.showPagination !== false"
       class="pagination-wrapper">
    <rappider-pagination [pageIndex]="paginationConfig?.pageIndex"
                         [total]="isDynamicPagination ? paginationConfig?.total : displayedData?.length"
                         [pageSize]="paginationConfig?.pageSize"
                         [showTotal]="rangeTemplate"
                         (pageIndexChange)="onPageIndexChange($event)"></rappider-pagination>
    <ng-template #rangeTemplate
                 let-range="range"
                 let-total>
      {{ range[0] }}-{{ range[1] }} of {{ isDynamicPagination ? paginationConfig?.total : displayedData?.length }}
      items
    </ng-template>
  </div>
</div>

<rappider-modal [visible]="previewConfig.modalVisibility"
                [title]="previewConfig.modalTitle"
                [closeIconVisibility]="true"
                [okText]="previewConfig.modalOkText"
                [cancelText]="previewConfig.modalCancelText"
                [width]="previewConfig.width"
                (cancelClick)="previewModalCancelClick()"
                (okClick)="previewModalOkClick()">
  <div class="cards-preview-modal-wrapper">
    <rappider-card-one [data]="previewConfig.selectedTemplatePreview?.data"
                       [image]="previewConfig.selectedTemplatePreview?.image"
                       [imageTags]="previewConfig.selectedTemplatePreview?.imageTags"
                       [imageButtons]="previewConfig.selectedTemplatePreview?.imageButtons"
                       [imageButtonPlacement]="previewConfig.selectedTemplatePreview?.imageButtonPlacement"
                       [rate]="previewConfig.selectedTemplatePreview?.rate"
                       [titles]="previewConfig.selectedTemplatePreview?.titles"
                       [currency]="previewConfig.selectedTemplatePreview?.currency"
                       [finalPrice]="previewConfig.selectedTemplatePreview?.finalPrice"
                       [price]="previewConfig.selectedTemplatePreview?.price"
                       [additionalTags]="previewConfig.selectedTemplatePreview?.additionalTags"
                       [additionalButtons]="previewConfig.selectedTemplatePreview?.additionalButtons"
                       [descriptions]="previewConfig.selectedTemplatePreview?.descriptions"
                       [isDescriptionsEnabled]="previewConfig.selectedTemplatePreview?.isDescriptionsEnabled"
                       [isTooltipEnabledOnDescription]="previewConfig.selectedTemplatePreview?.isTooltipEnabledOnDescription"
                       [avatar]="previewConfig.selectedTemplatePreview?.avatar"
                       [avatarButton]="previewConfig.selectedTemplatePreview?.avatarButton"
                       [avatarPlacement]="previewConfig.selectedTemplatePreview?.avatarPlacement"
                       [isSelected]="previewConfig.selectedTemplatePreview?.isSelected"
                       [selectedCardIcon]="previewConfig.selectedTemplatePreview?.selectedCardIcon"
                       [customIcon]="previewConfig.selectedTemplatePreview?.customIcon"
                       [disabledCard]="previewConfig.selectedTemplatePreview?.disabledCard"
                       [cardTooltipContent]="previewConfig.selectedTemplatePreview?.cardTooltipContent"
                       [cardTooltipPlacement]="previewConfig.selectedTemplatePreview?.cardTooltipPlacement"
                       [useDescriptionIfNoImage]="previewConfig.selectedTemplatePreview?.useDescriptionIfNoImage"
                       [borderSettings]="previewConfig.selectedTemplatePreview?.borderSettings"
                       (additionalButtonClick)="onPreviewAdditionalButtonClick($event)"></rappider-card-one>
  </div>
</rappider-modal>
